import { FC, lazy } from 'react'
import { RouteObject } from 'react-router-dom'
import { LazyComponent } from '../features/lazy-component'
import MobileScreenBlocker from '../__legacy__/components/core/MobileScreenBlocker'
import { Segment } from '../features/segment'

const Studio = lazy(() => import('../__legacy__/components/studio/Studio'))

const StudioPage: FC = () => (
  <Segment.ViewTracker attributes={{ path: '/studio'}}>
    <MobileScreenBlocker type="studio">
      <LazyComponent>
        <Studio />
      </LazyComponent>
    </MobileScreenBlocker>
  </Segment.ViewTracker>
)

export const StudioRoute: RouteObject = {
  path: '/studio',
  element: <StudioPage />
}
